export type PlanStep = {
  id: string;
  title: string;
};

export const getAdjacentSteps = <T extends PlanStep>(
  steps: T[],
  activeId: string
): { previous: T | null; next: T | null } => {
  const index = steps.findIndex((step) => step.id === activeId);
  if (index < 0) {
    return { previous: null, next: null };
  }

  return {
    previous: index > 0 ? steps[index - 1] : null,
    next: index < steps.length - 1 ? steps[index + 1] : null,
  };
};
